import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAppStore } from '@/store/useAppStore';
import { hasUnacceptedNonContentPolicyDocument } from '@/utils/onboardingUtils';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context: { auth }, location }) => {
    const isAuthenticated = auth?.isAuthenticated;
    if (!isAuthenticated) {
      const hrefString = location.href as string;
      const link = hrefString.startsWith('/')
        ? hrefString
        : (() => {
            try {
              const url = new URL(hrefString);
              return `${url.pathname}${url.search}${url.hash}`;
            } catch {
              return location.pathname;
            }
          })();

      throw redirect({
        to: '/sign-in',
        replace: true,
        search: {
          linkBack: link,
        },
      });
    }

    const { legalAcceptanceStatuses } = useAppStore.getState();
    const hasPendingEulaUpdate = hasUnacceptedNonContentPolicyDocument(legalAcceptanceStatuses);

    if (!auth?.isSuperAdmin && hasPendingEulaUpdate && location.pathname !== '/eula/update') {
      throw redirect({
        to: '/eula/update',
      });
    }
  },
});
